export default __webpack_public_path__ + "static/media/y_wdt_c_5.aa037d8f.mp3";